'use strict'
import axios from '../utils/axios'
import _ from 'lodash'
const token = process.env.REACT_APP_TOKEN
export default {
  async getJobs(env = 'dev', time = false, limit = 200, lastKey = '') {
    try {
      const axiosInstance = axios.getInstance(env, {}, true)
      const body = JSON.stringify({time, limit, lastKey})
      let requestResponse = await axiosInstance.post(`/jobs`, body)
      const response = {
        jobs: [],
        metadata: {
          lastKey: null,
          prevKeyUsed: lastKey,
          isLastChunk: false,
          lastChunkSize: -1
        }
      }
      if (!requestResponse || !requestResponse.data) {
        return response
      }
      // console.log('requestResponse', requestResponse)
      response.jobs = _.orderBy(_.get(requestResponse, 'data.jobs',[]),['start_time'],['desc'])
      response.metadata.lastKey = _.get(requestResponse, 'data.lastKey', null)
      response.metadata.lastChunkLoaded = response.jobs
      if (!response.metadata.lastKey) {
        response.metadata.isLastChunk = true
        response.metadata.lastChunkSize = response.jobs.length
      }
      // console.log('JOB PROCESSED Response ->', response)
      return response
    } catch (error) {
      console.error('getJobs', error.message)
      return {
        hasError: true,
        message:error.message
      }
    }
  },
  async getJobsByMediaId(env = 'dev', mediaId = false) {
    try {
      const axiosInstance = axios.getInstance(env, {}, true)
      let response = await axiosInstance.get(`/search/media?id=${mediaId}`)
      let data =  (!response) ? {jobs:[]} : response.data
      let sortedJobs = _.orderBy(data.jobs,['start_time'],['desc'])
      return {jobs: sortedJobs}
    } catch (error) {
      console.error('getJobsByMediaId', error.message)
    }
  },
  async getJobCounterByStatus(time = false, env = 'dev',){
    try {
      const axiosInstance = axios.getInstance(env, {}, true)
      let queryParam = `?`
      if(time){
        queryParam += `time=${time}`
      }
      let response = await axiosInstance.get(`/anaytics/jobs/counter/status${ (time) ? queryParam : ''}`)
      return (!response || response.status !== 200) ? {done: 0, error: 0, running: 0, total:0} : response.data
    } catch (error) {
      console.error('getJobCounterByStatus', error.message)
      return {done: 0, error: 0, running: 0, total:0}
    }
  },
  async getJobCounterByType(time = false, env = 'dev',){
    try {
      const axiosInstance = axios.getInstance(env, {}, true)
      let queryParam = `?`
      if(time){
        queryParam += `time=${time}`
      }
      let response = await axiosInstance.get(`/anaytics/jobs/counter/type${ (time) ? queryParam : ''}`)
      return (!response || response.status !== 200) ? {} : response.data
    } catch (error) {
      console.error('getJobCounterByType', error.message)
    }
  },
  async getJobCounterByStatusGroupByDate(time = false, env = 'dev',){
    try {
      const axiosInstance = axios.getInstance(env, {}, true)
      let queryParam = `?`
      if(time){
        queryParam += `time=${time}`
      }
      let response = await axiosInstance.get(`/anaytics/jobs/counter/status/date${ (time) ? queryParam : ''}`)
      return (!response || response.status !== 200) ? [] : response.data
    } catch (error) {
      console.error('getJobCounterByStatusGroupByDate', error.message)
    }
  },
  async getJobCounterByStatusGroupByAccounts(time = false, env = 'dev',){
    try {
      const axiosInstance = axios.getInstance(env, {}, true)
      let queryParam = `?`
      if(time){
        queryParam += `time=${time}`
      }
      let response = await axiosInstance.get(`/anaytics/jobs/counter/accounts${ (time) ? queryParam : ''}`)
      return (!response || response.status !== 200) ? [] : response.data
    } catch (error) {
      console.error('getJobCounterByStatusGroupByAccounts', error.message)
    }
  }
}



// WEBPACK FOOTER //
// ./src/requests/jobs.jsx